import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { column, report } from 'src/app/dashboards/models';
import { DashboardService } from 'src/app/services/services/dashboard.service';

@Component({
    selector: 'app-reports-dialog-help',
    templateUrl: './reports-dialog-help.component.html',
    styleUrls: ['./reports-dialog-help.component.scss'],
    standalone: false
})

export class ReportsDialogHelpComponent implements OnInit {

  allColumnsSelected:boolean=true;  

  constructor(private DashboardsService: DashboardService, public dialogRef: MatDialogRef<ReportsDialogHelpComponent>, @Inject(MAT_DIALOG_DATA) public data: report) { }

  ngOnInit(): void {
    this.DashboardsService.getReport(this.data.id, this.data.subReportId).subscribe(report => {
      this.data = report;
    });
  }
  
  getColumns(): column[] {
    let cols = this.allColumnsSelected ? this.data?.allColumns : this.data?.columns;
    return cols || [];
  }
}
